<template>
  <div class="forgetpassword-page">
    <div class="forgetpassword-page-inner">
      <div class="forgetpassword-page-box">
        <h1>Reset Your Password</h1>
        <div class="resetpassword-page-form">
          <div class="login-form-tips">
            <p v-if="passworderr">E-mail</p>
          </div>
          <el-input v-model="password" placeholder="New Password" show-password></el-input>
          <div class="login-form-tips">
            <p v-if="checkpassworderr">E-mail</p>
          </div>
          <el-input v-model="checkpassword" placeholder="Retype New Password" show-password></el-input>
          <el-button @click="onClickResetPassword()">Reset the password</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      'password': '',
      'checkpassword': '',
      'passworderr': false,
      'checkpassworderr': false,
      'code': null
    }
  },
  mounted() {
    if (this.$route.query.code) {
      this.code = this.$route.query.code
    }else{
      console.log("缺少code")
    }
  },
  methods:{
    onClickResetPassword: function(){
      console.log('onClickResetPassword')
      let that = this;
      let url = 'http://dashboard.api.trade-intelligence.com/basic/user/editpassword';
      let dataRegister = {
        code: that.code,
        password: btoa(that.password),//Base64加密：btoa(str)；解密：atob(base64)
      };
      console.log(dataRegister)
      $.ajax(url, {
        type: "POST",
        data: JSON.stringify(dataRegister),
        contentType: "application/json",
        success: function(data) {
          that.$router.push({ path: "/Login" });
          console.log(data)
        },
        error: function(response) {
          console.log(response)
        }
      })
    }
  }
}
</script>